__webpack_require__.p = "/graph-a-supply-curve/";